import { reactive } from 'vue'
import { apiFetch } from './api'

export interface Annotation {
  id: string
  systemId: string
  userId: string
  title: string
  content: string
  createdAt: string
  updatedAt: string
}

const state = reactive<{ items: Annotation[]; loaded: boolean }>({
  items: [],
  loaded: false
})

export const annotationsStore = {
  state,

  async refresh() {
    const data = await apiFetch<Annotation[]>('/annotations')
    state.items = data
    state.loaded = true
  },

  async create(payload: { title?: string; content: string }) {
    const ann = await apiFetch<Annotation>('/annotations', {
      method: 'POST',
      body: JSON.stringify(payload)
    })
    state.items.unshift(ann)
    return ann
  },

  async update(id: string, payload: { title?: string; content?: string }) {
    const ann = await apiFetch<Annotation>(`/annotations/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(payload)
    })
    const idx = state.items.findIndex(a => a.id === id)
    if (idx !== -1) state.items[idx] = ann
    return ann
  },

  async remove(id: string) {
    await apiFetch(`/annotations/${id}`, { method: 'DELETE' })
    state.items = state.items.filter(a => a.id !== id)
  }
}
